import React, { useState, useEffect } from 'react';
import { SVBCard, SVBTypography } from '@svb/svb-react-components';
import { Link } from 'react-router-dom';
import { slugCreator } from '../../../core/useStore';

export default function SVBFaqMostCommonResult(props) {
  const [mounted, setMounted] = useState(false);
  const sub_Heading_Faqs = 'Most Common Questions';
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(props?.cardJson);
    setMounted(true);
  }, []);

  if (!mounted) {
    return <></>;
  }
  return (
    <>
      <div className='col-md-12 col-sm-12 pt-4 pb-4'>
        <SVBTypography type='heading-large' variant='heading-medium'>{sub_Heading_Faqs}</SVBTypography>
      </div>
      {data?.map((faqData, i) => {
        let faq_tags = [];
        faqData?.tags?.filter(
          (item) =>
            item.name !== 'common' &&
            item.value &&
            faq_tags.push({ label: item.value, type: 'faq' }),
        );
        const faq_mostcommon = faqData?.tags?.find(
          (item) => item.name === 'common' && item.value[0] === 'true',
        );
        return faq_mostcommon ? (
          <div className='col-md-6 col-sm-6 pb-4' role='button' key={i} data-testid={slugCreator(faqData?.title)}>
            <Link
              to={`/faqs/${slugCreator(faqData?.title)}`}
              state={{
                folder: faqData?.document_location,
              }}
            >
              <SVBCard
                title={faqData.title}
                description={faqData.description}
                categories={{
                  tagsPosition: 'footer',
                  extraClasses: 'me-2',
                  tags: faq_tags,
                }}
              ></SVBCard>
            </Link>
          </div>
        ) : null;
      })}
    </>
  );
}
